function getOpt (data) {
 let fontSize1, fontSize2, lineColor, fontColor;
 if (data.name !="国四") {
  fontSize1 = 45;
  fontSize2 = 20;
  lineColor = '#32C5FF';
  fontColor = '#FFF'
 } else {
  fontSize1 = 45;
  fontSize2 = 20;
  lineColor = '#FF0012';
  fontColor = '#FF0012'
 }
 return {
  series: [{
   type: 'gauge',
   startAngle: 90,
   endAngle: -270,
   pointer: {
    show: false
   },
   progress: {
    show: true,
    overlap: false,
    roundCap: true,
    clip: false,
    width: 3,
    itemStyle: {
     color: lineColor
    }
   },
   axisLine: {
    roundCap: false,
    lineStyle: {
     width: 3,
     // color:'#297EFF'
     color: [[1, '#297EFF']]
    }
   },
   splitLine: {
    show: false,
   },
   axisTick: {
    show: false
   },
   axisLabel: {
    show: false,
    distance: 10
   },
   data: [{
    value: data.bai,
    name: data.num,
   }],
   center: [50, 50],
   radius: 50,
   title: {
    fontSize: fontSize1,
    color: fontColor,
    fontWeight: 500,
    offsetCenter: ['0%', '-5%']
   },
   detail: {
    fontSize: fontSize2,
    color: fontColor,
    borderWidth: 0,
    formatter: data.bai+'%',
    offsetCenter: ['0%', '50%']
   }
  }]
 };
}

export default getOpt